<template>
  <grid class="c-m g-m">
    <row class="c-m" :reverse="!1" end="xs" middle="xs">
      <column :xs="3">
        <b>{{$t('settings.map.type_label')}}</b>
      </column>
      <column :xs="7">
        <label class="dock-pull-select-label">
          <select class="dock-pull-select" v-model="currentTile">
            <option value="wiki">{{$t('settings.map.type.osm')}}</option>
            <option value="google">{{$t('settings.map.type.google')}}</option>
<!--            <option value="google_terrain">{{$t('settings.map.type.google_terrain')}}</option>-->
            <option value="yandex">{{$t('settings.map.type.yandex')}}</option>
          </select>
        </label>
      </column>
      <column :xs="2"></column>
    </row>
    <row class="c-m" :reverse="!1" end="xs" middle="xs">
      <column :xs="3">
        <b>{{$t('settings.map.objects_label')}}</b>
      </column>
      <column :xs="7">
        <label class="dock-pull-select-label">
          <select class="dock-pull-select" v-model="objectsVisible">
            <option value="1">{{$t('show_label')}}</option>
            <option value="0">{{$t('hide_label')}}</option>
          </select>
        </label>
      </column>
      <column :xs="2"></column>
    </row>
    <row class="c-m" :reverse="!1" end="xs" middle="xs">
      <column :xs="3">
        <b>{{$t('settings.map.points_label')}}</b>
      </column>
      <column :xs="7">
        <label class="dock-pull-select-label">
          <select class="dock-pull-select" v-model="historyPoints">
            <option value="1">{{$t('show_label')}}</option>
            <option value="0">{{$t('hide_label')}}</option>
          </select>
        </label>
      </column>
      <column :xs="2"></column>
    </row>
    <row class="c-m" :reverse="!1" end="xs" middle="xs">
      <column :xs="3">
        <b>{{$t('settings.map.geozone_label')}}</b>
      </column>
      <column :xs="7">
        <label class="dock-pull-select-label">
          <select class="dock-pull-select" v-model="geozones">
            <option value="1">{{$t('show_label')}}</option>
            <option value="0">{{$t('hide_label')}}</option>
          </select>
        </label>
      </column>
      <column :xs="2"></column>
    </row>
  </grid>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'Map',
  computed: {
    ...mapGetters(['getMap']),
    objectsVisible: {
      set (n) {
        this.setMapParams({name: 'objectOptions',
          value: {
            ...this.getMap.objectOptions, visible: !!parseInt(n)
          },
          updateLs: 1})
      },
      get () {
        return this.getMap.objectOptions.visible ? '1' : '0'
      }
    },
    historyPoints: {
      set (n) {
        this.setMapParams({
          name: 'objectOptions',
          value: {
            ...this.getMap.objectOptions, history_points: !!parseInt(n)
          },
          updateLs: 1
        })
      },
      get () {
        return this.getMap.objectOptions.history_points ? '1' : '0'
      }
    },
    geozones: {
      set (n) {
        this.setMapParams({
          name: 'objectOptions',
          value: {
            ...this.getMap.objectOptions, geozones: !!parseInt(n)
          }
        })
      },
      get () {
        return this.getMap.objectOptions.geozones ? '1' : '0'
      }
    },
    currentTile: {
      set (n) {
        this.setMapParams({name: 'currentTile', value: n, updateLs: 1})
      },
      get () {
        return this.getMap.currentTile
      }
    }
  },
  methods: {
    ...mapActions(['setMapParams'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/settings/Map.vue